/* ==========================================================================
   CART GIFTS — Brinde no carrinho (Singular)
   Anima a barra a partir do valor anterior e destaca o brinde quando é desbloqueado.
   A barra funciona 100% sem este JS (a largura vem do Liquid); aqui é só animação.
   ========================================================================== */
(() => {
  if (window.customElements.get('cart-gifts')) return;

  const STORAGE_KEY = 'singular:cart-gifts';

  const readState = () => {
    if (window.__cartGiftsState) return window.__cartGiftsState;
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  };

  const writeState = (state) => {
    window.__cartGiftsState = state;
    try {
      if (state) {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } else {
        sessionStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) { /* storage indisponível: segue só com memória */ }
  };

  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class CartGifts extends HTMLElement {
    connectedCallback() {
      const progress = parseFloat(this.dataset.progress) || 0;
      const tier = parseInt(this.dataset.tier, 10) || 0;
      const isPage = this.classList.contains('cart-gifts--page');
      const prev = readState();

      writeState({ progress, tier });

      if (reducedMotion()) return;

      let from = null;

      if (prev && prev.progress !== progress) {
        from = prev.progress;
      } else if (!prev && isPage) {
        from = 0;
      }

      if (from !== null) {
        const fill = this.querySelector('.cart-gifts__fill');

        if (fill) {
          const previousTransition = fill.style.transition;
          fill.style.transition = 'none';
          fill.style.width = `${from}%`;
          fill.getBoundingClientRect(); // força o reflow antes de animar
          fill.style.transition = previousTransition;

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              fill.style.width = '';
            });
          });
        }
      }

      const prevTier = prev ? prev.tier : (isPage ? 0 : tier);

      if (tier > prevTier) {
        this.querySelectorAll('.cart-gifts__milestone').forEach((milestone) => {
          const milestoneTier = parseInt(milestone.dataset.tier, 10);

          if (milestoneTier > prevTier && milestoneTier <= tier) {
            milestone.classList.add('is-just-unlocked');
            setTimeout(() => milestone.classList.remove('is-just-unlocked'), 1400);
          }
        });
      }
    }
  }

  window.customElements.define('cart-gifts', CartGifts);

  // Carrinho esvaziado: zera o estado para a próxima animação começar do zero
  document.addEventListener('cart:change', (event) => {
    const cart = event.detail && event.detail.cart;

    if (cart && cart.item_count === 0) {
      writeState(null);
    }
  });
})();
